import { createSlice } from "@reduxjs/toolkit";
// ⚠️ Deep-imports the DESKTOP variant on purpose — hazard 6. `userLogout`/`supportLogout`
// are web-only, and a bare `../LoginSlice` typechecks against the NATIVE variant because
// packages/core's tsconfig sets `moduleSuffixes: [".native", ".shared", ".desktop", ""]`.
import { supportLogout, userLogout } from "../LoginSlice";
import { sharedInitialState, sharedReducers } from "./shared";
import type { SharedSlice } from "./shared";

// `Slice` is no longer a local extension: web adds no state field of its own any more —
// `programDetailsMap` moved to ./shared on 2026-09-05 when mobile took the same loyalty flow.
type Slice = SharedSlice;

const initialState: Slice = {
  ...sharedInitialState,
  // Web starts empty. Mobile seeds fixture data here instead — see index.native.ts.
  loyaltyDetails: {
  },
}

export const LoyaltySlice = createSlice({
  name: 'loyaltyData',
  initialState,
  reducers: {
    ...sharedReducers,
    // Web adds no reducer of its own any more — `getProgramDetailsSuccess` / `clearProgramDetails`
    // joined the trigger in ./shared on 2026-09-05, when mobile took the same loyalty flow.
  },
  // Web-only, and unlike MyOrderSlice/OutletStatusSlice these have REAL bodies:
  // userLogout clears only the program-details cache, supportLogout resets the whole slice.
  extraReducers: (builder) => {
    builder
      .addCase(userLogout, (state) => {
        state.programDetailsMap = {};
      })
      .addCase(supportLogout, (state) => initialState);
  },
});

export const {
  getLoyaltyProviders,
  getLoyaltyProvidersSuccess,
  getLoyaltyDetails,
  selectedLoyaltyDetails,
  getLoyaltyDetailsSuccess,
  redeemPoints,
  redeemPointsSuccess,
  verifyLoyaltyOtp,
  verifyLoyaltyOtpSuccess,
  refundLoyaltyPoints,
  resetLoyaltyProviders,
  updateLoyaltySlice,
  externalOfferVerify,
  customerOfferList,
  toggleLoyaltyModal,
  unBlockExternalDiscount,
  externalCouponRefId,
  sendCustomerConsentOtp,
  verifyCustomerConsentOtp,
  customerOptOut,
  getProgramDetails,
  getProgramDetailsSuccess,
  clearProgramDetails
} = LoyaltySlice.actions

export default LoyaltySlice.reducer;
